import { CardBackLayout } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';

import CARD_BACK_TYPOGRAPHY from './images/typography.png';
import CARD_BACK_MONOGRAM from './images/monogram.png';
import CARD_BACK_BLANK from './images/blank.png';
import CARD_BACK_KINDLYRSVP from './images/kindly_rsvp.back.png';
import CARD_BACK_THEDETAILS from './images/the_details.back.png';
import CARD_BACK_LETSCELEBRATE from './images/lets_celebrate.back.png';

import cardBackTypography from './json/back.typography.invite.json';
import cardBackMonogram from './json/back.monogram.invite.json';
import cardBackKindlyRsvp from './json/kindly_rsvp.back.json';
import cardBackTheDetails from './json/the_details.back.json';
import cardBackLetsCelebrate from './json/lets_celebrate.back.json';

export const LAYOUT_TO_NAME = {
  [CardBackLayout.typography]: 'Typography',
  [CardBackLayout.monogram]: 'Monogram',
  [CardBackLayout.kindly_rsvp]: 'Kindly RSVP',
  [CardBackLayout.the_details]: 'The Details',
  [CardBackLayout.lets_celebrate]: "Let's Celebrate",
  [CardBackLayout.blank]: 'Blank'
} as const;

export const LAYOUT_TO_IMAGE = {
  [CardBackLayout.typography]: CARD_BACK_TYPOGRAPHY,
  [CardBackLayout.monogram]: CARD_BACK_MONOGRAM,
  [CardBackLayout.kindly_rsvp]: CARD_BACK_KINDLYRSVP,
  [CardBackLayout.the_details]: CARD_BACK_THEDETAILS,
  [CardBackLayout.lets_celebrate]: CARD_BACK_LETSCELEBRATE,
  [CardBackLayout.blank]: CARD_BACK_BLANK
} as const;

export const LAYOUT_TO_JSON = {
  [CardBackLayout.typography]: cardBackTypography,
  [CardBackLayout.monogram]: cardBackMonogram,
  [CardBackLayout.kindly_rsvp]: cardBackKindlyRsvp,
  [CardBackLayout.the_details]: cardBackTheDetails,
  [CardBackLayout.lets_celebrate]: cardBackLetsCelebrate,
  [CardBackLayout.blank]: []
} as const;
